import { useState } from "react";
import AuthService from "../../../api/authService";
import { useNotification } from "../../../context/NotificationContext";
import { useLoader } from "../../../context/LoaderContext";

export default function ForgotPasswordForm({ onSwitch }) {
  const [email, setEmail] = useState("");
  const { showNotification } = useNotification();
  const { showLoader, hideLoader } = useLoader();

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader("form-wrapper");
    try {
      const res = await AuthService.forgotPassword(email);
      showNotification("info", res.message || "Email de réinitialisation envoyé !");
      setEmail("");
    } catch (error) {
      showNotification(
        "error",
        error.response?.data?.error || "Erreur lors de l’envoi de l’email."
      );
    } finally {
      hideLoader();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="space-y-1">
        <label className="block text-sm font-semibold text-slate-700">
          Adresse e-mail associee a ton compte
        </label>
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="ton@email.com"
          className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-sm text-pixy-ink outline-none transition placeholder:text-slate-400 focus:border-pixy-blue focus:ring-2 focus:ring-pixy-blue/20"
        />
      </div>

      <button
        type="submit"
        className="w-full rounded-2xl bg-gradient-to-r from-pixy-green to-pixy-blue px-4 py-3.5 text-sm font-bold uppercase tracking-[0.22em] text-white shadow-md shadow-sky-300/30 transition hover:-translate-y-0.5 hover:shadow-sky-300/50"
      >
        Reinitialiser le mot de passe
      </button>

      <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-600 text-center">
        <button
          type="button"
          onClick={() => onSwitch("login")}
          className="font-semibold text-pixy-blue transition hover:text-pixy-green"
        >
          Retour a la connexion
        </button>
      </div>
    </form>
  );
}
